import { Routes, Route } from "react-router-dom";
import { Users } from "@/pages/Users/Users";

export const UsersRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<Users />} />
        </Routes>
    );
};
